import { useQuery } from 'react-query'
import * as api from 'app/api/enterpriseCannedServices'

export const QUERY_KEY = 'cannedServices'

export const useCannedServicesQuery = () => {
	return useQuery(QUERY_KEY, () => api.getCannedServices())
}
